import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, Dialog } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import { translator } from "../utils/i18n";
import { forgotPassword } from "../utils/session";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { connect } from "react-redux";

const styles = () => ({
  dialog: {
    borderRadius: "15px"
  }
});

class ForgotPassword extends Component {
  state = {
    open: false,
    response: "",
    email: "",
    isValid: 0
  };

  handleClickOpen = e => {
    e.preventDefault();
    this.setState({ open: true });
  };

  handleClose = e => {
    e.preventDefault();
    this.setState({ open: false });
  };

  handleChange = e => {
    this.setState({ email: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();
    const result = await this.props.forgotPassword({ email: this.state.email });
    if (result.response.result == "ok") {
      this.setState({ response: result.response.message, isValid: 1 });
    } else {
      this.setState({ response: result.response.message, isValid: 0 });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <button
          type="button"
          onClick={this.handleClickOpen}
          className="forgot-password no-style-btn"
        >
          <Trans id="W_STEP4_ACCES_MEMBRE_MOT_DE_PASSE_OUBLIE" />
        </button>
        <Dialog
          aria-labelledby="priority-dialog-title"
          open={this.state.open}
          onClose={this.handleClose}
          classes={{
            paper: classes.dialog
          }}
        >
          <DialogTitle className="head-dialog" id="priority-dialog-title">
            <div className="title-dialog">
              <i className="material-icons">mail_outline</i>
              <span className="title-text">
                <Trans id="W_STEP4_POPUP_TITRE_MOT_DE_PASSE_OUBLIE" />
              </span>
            </div>
          </DialogTitle>

          <div className="body-dialog">
            <form className="form-priority-code">
              {this.state.response && (
                <div
                  className={
                    this.state.isValid === 1
                      ? "custom-message custom-success d-flex align-items-center mb-10"
                      : "custom-message custom-alert d-flex align-items-center mb-10"
                  }
                >
                  {this.state.isValid === 1 ? (
                    <CheckCircleIcon />
                  ) : (
                    <ErrorIcon />
                  )}
                  {this.state.response}
                </div>
              )}
              {!this.state.isValid && (
                <React.Fragment>
                  <label
                    htmlFor="forgot-password"
                    className="text color-font-main-md"
                  >
                    <Trans id="W_STEP4_POPUP_MOT_DE_PASSE_OUBLIE_ENTRER_VOTRE_ADRESSE_MAIL" />
                  </label>
                  <input
                    type="email"
                    id="forgot-password"
                    placeholder={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    className="mb-20"
                  />

                  <Button
                    type="submit"
                    onClick={this.handleSubmit}
                    disabled={this.state.email === ""}
                    color="primary"
                    variant="contained"
                    className="btn-filled"
                  >
                    <Trans id="W_VALIDER" />
                  </Button>
                </React.Fragment>
              )}
              {this.state.isValid !== 0 && (
                <Button type="submit" onClick={this.handleClose}>
                  <Trans id="W_STEP_BOUTON_FERMER" />
                </Button>
              )}
            </form>
          </div>
        </Dialog>
      </>
    );
  }
}

ForgotPassword.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  forgotPassword: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    forgotPassword: (values, success) =>
      dispatch(forgotPassword(values, success))
  };
};

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(ForgotPassword)
);
